
import Component from "vue-class-component";
import Vue from "vue";
import ItemTypeModule  from "@/store/modules/barcodeSystem/itemType";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { EditBarcodeManufacturerModel } from "@/models/ui/editBarcodeManufacturer";
import { formatBool } from "@/utils";

const itemTypeModuleState = getModule(ItemTypeModule);
import notifications from "../../lib/notifications";
import { ItemTypeResource } from "@/models/api/barcodeSystem/itemTypes/get";
@Component({
  components: {
    Select
  }
})
export default class ItemTypes extends Vue {
  itemTypes: ItemTypeResource[] = null;
  loading: boolean = false;
  saving: boolean = false;
  promptDelete: boolean = false;
  showAddItemTypeModal: boolean = false;
  deleteItemTypeValue: string = null;
  itemTypeValue: string = null;
  itemTypeFilter: string = null;

  async created() {
    await this.loadItemTypes();
  }

  async loadItemTypes() {
    this.loading = true;
    await itemTypeModuleState.loadItemTypes();
    this.itemTypes = itemTypeModuleState.itemTypes;
    this.loading = false;
  }

  get filteredItemTypes() {
    if(this.itemTypeFilter) 
      return this.itemTypes.filter(x => x.itemTypeValue.toUpperCase().startsWith(this.itemTypeFilter.toUpperCase()));
    else
      return this.itemTypes;
  }

  formatBool(val: string)
  {
    return formatBool(val);
  }

  itemTypeValueState() {
    return this.itemTypeValue ? null : false;
  }

  validateForm() {
    if(this.itemTypeValueState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveItemType() {
    if(!this.validateForm()) return;
    try {
      this.saving = true;
      await itemTypeModuleState.createItemType({itemTypeValue: this.itemTypeValue});   
      notifications.success("Item Type Saved", "Successfully saved item type.");
      await this.loadItemTypes();
      this.closeModals();
    } catch (ex) {
      notifications.error("Save Item Type", "Failed to save item type", ex);
      this.saving = false;
    }
  }  
  
  async deleteItemType() {
    try {
      this.saving = true;
      await itemTypeModuleState.deleteItemType(this.deleteItemTypeValue);   
      notifications.success("Item Type Deleted", "Successfully deleted item type");
      await this.loadItemTypes();
      this.closeModals();
    } catch (ex) {
      notifications.error("Delete Item Type", "Failed to delete item type", ex);
      this.saving = false;
    }
  }

  promptForDelete(itemTypeValue: string) {      
    this.saving = false;
    this.deleteItemTypeValue = itemTypeValue;
    this.promptDelete = true;
  }

  closeModals() {
    this.deleteItemTypeValue = null;
    this.itemTypeValue = null;
    this.showAddItemTypeModal = false;
    this.promptDelete = false;
  }

  addItemType() {      
    this.saving = false;
    this.itemTypeValue = null;
    this.showAddItemTypeModal = true;
  }
}
